import { Button, Center, CloseButton, ModalProps, Text } from '@chakra-ui/react'
import { Modal, ModalOverlay, ModalContent, ModalBody, ModalFooter, ModalHeader, ModalChakra } from '@wow/modal'
import { themeChakra } from '@wow/themes'
import React from 'react'
import buttonStyle from '../../Theme/components/buttonStyle'

interface ModalReferralsProps extends Omit<ModalProps, 'children'> {
  onSubmit: () => void;
}

const title1 =  '¡Listo! Enviamos un email al'
const title2 =  'contacto en la empresa'
const subTitle = 'Te contactaremos cuando se suscriba a Interbanking. ¡Seguí refiriendo y ganá!'

const ModalReferrals = ({ isOpen, onClose, onSubmit }: ModalReferralsProps) => {
  const handleOnSubmit = () => {
    onSubmit()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size='2xl' closeOnOverlayClick={false} data-testid='modalReferrals'>
      <ModalOverlay data-testid='overlay' />
      <ModalContent mt={40}>
        <CloseButton onClick={onClose} sx={ModalChakra.close} color={themeChakra.colors.black[100]} size='lg' data-testid='closeButton' />
        <ModalHeader textAlign='center' >
          <Center width={'612px'}><Text textStyle='h4.bold' lineHeight='2xl'>{title1}</Text></Center>
          <Center width={'612px'}><Text textStyle='h4.bold' lineHeight='2xl'>{title2}</Text></Center>
        </ModalHeader>
        <ModalBody textAlign='center'>
          <Center width={'612px'}>
            <Text width='660px' textStyle='body.lg' lineHeight='xm' fontWeight='400px' size='xs'>{subTitle}</Text>
          </Center>
        </ModalBody>
        <ModalFooter justifyContent='center'>
          <Button
            data-testid='modal-submit'
            id='data-submit'
            variant='primary'
            style={buttonStyle.buttonPurple}
            width={156}
            size={'md'}
            p={ ["0px", "12px", "0px", "12px"]}
            type='submit'
            onClick={handleOnSubmit}
            loadingText='Referir otra empresa'
          >
            Referir otra empresa
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default ModalReferrals
